<template>
  <div style="position:relative">
    <div>
      <span class="title" style="margin-bottom:10px;display:block">阿尔法认知（客户经理&数据人员汇总）：</span>
      <pre v-if="company.公司备注" class="company-pre" style="margin-bottom:10px">{{ company.公司备注 }}</pre>
      <span class="title" style="margin-bottom:10px;display:block">阿尔法认知（顾问填写）：</span>
      <div style="padding-left:20px">
        <div class="edit-dialog-input-wrap">
          <el-input v-model="阿尔法认知" type="textarea" :rows="2"></el-input>
          <el-button size="mini" style="position:absolute;bottom:0;right:0" type="primary" class="custom-primary-plain" @click="alphaCognitiveAddLog(true)">保存</el-button>
        </div>
        <div>
            <div v-for="(item,k) in showLogs" :key="k" class="edit-dialog-single-p" style="flex-wrap:wrap">
              <b style="font-weight:normal">{{ (item.updatedAt||item.createdAt) | formatdate }} -- {{ item.account }}<i v-if="isAdmin || item.account===account" class="el-icon-delete ml10" style="flex:none;color:#de5c65;cursor:pointer;" @click="alphaCognitiveRemoveLog(item)"></i></b>
              <div style="display:flex;width: 100%;align-items: flex-start;margin-top:10px;">
                <i class="el-icon-info mr10" style="flex:none"></i><span style="flex:auto;display: inline-block;white-space: pre-wrap;word-break: break-word;">{{ item.content }}</span>
              </div>
            </div>
        </div>
      </div>

    </div>
  </div>
</template>
<script>

export default {
  filters: {
    formatdate: function (date) {
      const createdDate = new Date(date)
      if (!date) {
        return
      }
      return `${createdDate.getFullYear()}-${
        createdDate.getMonth() + 1
      }-${createdDate.getDate()}  ${createdDate.getHours()}:${
        createdDate.getMinutes() < 10 ? `0${createdDate.getMinutes()}` : createdDate.getMinutes()
      }`
    },
  },
  props: {
    company: { type: Object, default: () => {} },
  },
  data() {
    return {
      阿尔法认知: '',
      isAdmin: false,
      account:'',
    }
  },
  computed: {
    showLogs() {
      const logs = window._.cloneDeep(this.company.阿尔法认知 || [])
      logs.sort((a, b) => b.updatedAt - a.updatedAt)
      return logs
    },
  },
  mounted(){
    this.isAdmin = app.user.角色 && app.user.角色.includes('管理员')
    this.account = app.user.account
  },
  methods: {
    async alphaCognitiveAddLog(confirm = false){
      if (!this.阿尔法认知) return this.$message.error('请填写要保存的内容')
      const log = { updatedAt: Date.now(), account: app.user.account, content: this.阿尔法认知 }
      this.阿尔法认知 = ''
      const res = await app.service('company').alphaCognitiveAddLog({
        cid: this.company._id,
        log: log,
      })
      if (res.status === 'success') {
        this.$set(this.company, '阿尔法认知', res.data)
      }
    },
    async alphaCognitiveRemoveLog(log){
      this.$confirm('确定要移除这条日志吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async() => {
        const res = await app.service('company').alphaCognitiveRemoveLog({
          cid: this.company._id,
          log: log,
        })
        if (res.status === 'success') {
          this.$message.success('移除成功');
          this.$set(this.company, '阿尔法认知', res.data)
        }else this.$message.error(res.msg)
      }).catch(() => {
        this.$message.info('已取消删除');
      });
    },
  },
}
</script>
<style src="../../../../company/statistics/css/fullCompanyDetail.css" scoped></style>
<style src="../../../../company/statistics/css/commonCompany.css" scoped></style>
<style scoped>
.gray-box {
  background-color: #eee;
  padding: 10px;
  margin-bottom: 10px;
  font-size: 14px;
}
.edit-dialog-single-p b {
  color: #aaa;
  margin-right: 16px;
  font-size: 14px;
}
.edit-dialog-input-wrap-border {
  border: 1px solid #eaeaea;
  width: 100%;
  padding: 10px;
  border-radius: 4px;
}
.company-alpha-cognize {
  display: flex;
  justify-content: space-around;
}
.company-alpha-cognize span {
  width: 25%;
  /* text-align: center; */
}
.company-pre {
  background-color: #fff;
}
</style>
